import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    title: 'La Guía Maestra: Menopausia Sin Niebla',
    description: 'PDF completo con todo el protocolo'
  }, {
    title: 'El Plan de Acción de 21 Días',
    description: 'Tu hoja de ruta paso a paso desde la extinción del incendio hasta la claridad total'
  }, {
    title: 'Checklist de Supermercado "Cerebro Vivo"',
    description: 'Los alimentos exactos que reparan la membrana neuronal'
  }, {
    title: 'Diario de Rastreo de Claridad',
    description: 'Para medir tu progreso real en enfoque y memoria'
  }, {
    title: 'Protocolo de Sueño Reparador',
    description: 'El ritual de enfriamiento cerebral para despertar con la mente limpia'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-188">
      <div className="max-w-4xl mx-auto px-6" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-teal-900" data-id="element-191">
            Lo Que Recibes
          </h2>

          <div className="space-y-6" data-id="element-192">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start bg-cream p-6 rounded-lg" data-id="element-193">
                <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-194" />
                <div data-id="element-195">
                  <h3 className="font-bold text-lg text-gray-900 mb-1" data-id="element-196">
                    {item.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-197">{item.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}